import { FormProvider } from 'react-hook-form';

import { Button, ButtonType } from '@xemplo/button';

import { PayrunApprovalModal } from './modal/modal';
import { TestIds } from './create-payrun-approver-test.helper';
import * as S from './create-payrun-approvers.style';
import { CreatePayrunApproversProps } from './create-payrun-approvers.types';
import { useCreatePayrunApprover } from './use-create-payrun-approvers';

export function CreatePayrunApprovers(props: Readonly<CreatePayrunApproversProps>) {
  const { buttonProps, buttonChildren, onSuccess, className, companyId } = props;

  const { modalDialog, handleSubmit, errorMessage, setErrorMessage, methods } =
    useCreatePayrunApprover({
      companyId,
    });

  function handleReset() {
    methods.reset();
    modalDialog.closeDialog();
  }

  const onClick = () => {
    setErrorMessage(null);
    modalDialog.openModalDialog();
  };

  return (
    <FormProvider {...methods}>
      <S.ButtonDiv className={className}>
        <Button
          ariaLabel="Add Approver"
          type={ButtonType.Primary}
          testId={TestIds.NewPayrunApproverButton}
          {...buttonProps}
          onClick={onClick}
        >
          {buttonChildren ?? 'New Approver'}
        </Button>

        <PayrunApprovalModal
          {...modalDialog}
          handleSubmit={handleSubmit}
          cancelCallback={handleReset}
          companyId={companyId}
          errorMessage={errorMessage}
          onSuccess={onSuccess}
        />
      </S.ButtonDiv>
    </FormProvider>
  );
}
